import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-checklist-edit-checkpoint-remove-button',
    templateUrl: './checkpoint-remove-button.component.html',
    styleUrls: ['./checkpoint-remove-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-edit-checkpoint-remove-button' },
    standalone: false,
})
export class CheckpointRemoveButtonComponent {
    @Input() disabled: boolean = false;
    @Input() checklist;

    @Output() removeClick = new EventEmitter();

    constructor(private appTextService: AppTextService) {}

    _removeClick() {
        this.removeClick.emit();
    }

    getDeleteButtonTitle() {
        if (!this.disabled) {
            return '';
        }

        if (this.checklist.IsWithResponses) {
            return this.appTextService.get('checklist.remove_checkpoint_delete_responses');
        }
    }
}
